import AbstractScreenMediator from "../../app/ui/AbstractScreenMediator";
import Anchor from "../../../../lib/html5-software-library/src/ranj/layout/Anchor";
import StartupEvent from "../../app/startup/StartupEvent";
import Config from "../../app/config/Config";

export default class BasePreloadScreenMediator extends AbstractScreenMediator {

    constructor(target, dispatcher, layoutManager, soundManager, startup, config) {
        super(target, dispatcher, null, layoutManager, soundManager, startup);
        this._startup = startup;
        this._config = config;
        this._handleLoadProgressBound = this._handleLoadProgress.bind(this);
    }

    initialize() {
        super.initialize();

        // Center the preload screen
        if (this._target) {
            this.anchorObject(this._target, Anchor.C);
        }

        // Listen to startup progress events
        this._startup.addEventListener(StartupEvent.PROGRESS, this._handleLoadProgressBound);

        this._logVersion();
    }

    destroy() {
        if (this._startup) {
            this._startup.removeEventListener(StartupEvent.PROGRESS, this._handleLoadProgressBound);
        }
        super.destroy();
    }

    _logVersion() {
        const version = this._config.getValue(Config.VERSION);
        const commitHash = this._config.getValue(Config.COMMIT_HASH);

        console.log(`Version: ${version} (${commitHash})`);
    }

    _setProgress(progress) {
        if (this._target.loadingBar) {
            const t = this._target.loadingBar.totalFrames;
            const percentage = Math.round((t - 1) * progress);
            this._target.loadingBar.gotoAndStop(Math.min(t - 1, percentage));
        }
    }

    _handleLoadProgress({ data }) {
        this._setProgress(data.progress);
    }
}
